<template>
  <select2-multiple-control
    :id="id"
    :value="value"
    :options="options"
    :required="required"
    :disabled="disabled"
    :settings="comboSettings"
    :placeholder="placeholder"
    @change="update"
    @select="optionSelected"
  />
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      default: () => "multi-" + self.crypto.randomUUID(),
    },
    url: {
      type: String,
      default: "",
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const comboSettings = {
      placeholder: this.placeholder,
      theme: "bootstrap",
      dropdownAutoWidth: true,
      width: "100%",
    };

    if (this.url != "") {
      comboSettings.ajax = {
        url: process.env.VUE_APP_ENDPOINT + this.url,
        xhrFields: {
          withCredentials: true,
        },
        dataType: "json",
        processResults: function (responseData) {
          let items = [];
          if ("results" in responseData) {
            items = responseData.results;
          } else if ("items" in responseData) {
            items = responseData.items;
          } else {
            items = responseData;
          }

          const results = items.map(function (item) {
            if ("label" in item) {
              return { id: item.id, text: item.label };
            }
            if ("value" in item) {
              return { id: item.value, text: item.text };
            }
            return item;
          });
          return { results: results };
        },
        delay: 250,
      };
    }

    return {
      valuemut: [...this.value],
      comboSettings: comboSettings,
    };
  },
  methods: {
    update(value) {
      this.valuemut = value;
      this.$emit("input", this.valuemut);
    },
    optionSelected(lastSelected) {
      this.$emit("selected", lastSelected);
    },
  },
};
</script>
